import React, { useEffect, useRef } from 'react';
import PanchTatvaCard from '../components/PanchTatvaCard';
import products from '../data/products';
import { useStrings } from '../i18n';

export default function Shop() {
  const sectionRef = useRef([]);
  const strings = useStrings();

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('show');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    sectionRef.current.forEach((el) => {
      if (el) observer.observe(el);
    });
  }, []);

  return (
    <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-20 space-y-8 md:space-y-12">
      <h1 className="text-3xl md:text-5xl font-heading text-headingText text-center fade-section" ref={(el) => (sectionRef.current[0] = el)}>
        {strings.shop.title}
      </h1>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-10">
        {products.map((product, i) => (
          <PanchTatvaCard
            key={product.id}
            {...product}
            className={`shimmer-hover fade-section delay-${i * 100}`}
            ref={(el) => (sectionRef.current[i + 1] = el)}
          />
        ))}
      </div>
    </div>
  );
}
